import { useCallback, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { WebsiteForm } from '../components';
import Frame from '../layout/Frame';
import useErrorHandler from '../hooks/useErrorHandler';
import { createWebsite } from '../requests/requests';
import { AppRoute } from '../types/enums';
import { WebsiteSettings } from '../types/types';
import { DataContext } from '../App';
import Panel from '../layout/Panel';

const NewWebsite = () => {
  const navigate = useNavigate();
  const errorHandler = useErrorHandler();
  const { refreshWebsites } = useContext(DataContext);

  const onSave = useCallback((form: WebsiteSettings) => {
    createWebsite(form).then(({ data }) => {
      refreshWebsites();
      navigate(AppRoute.WEBSITE_CREATED, {
        state: data
      });
    }, errorHandler);
  }, []);

  return (
    <Frame>
      <Panel>
        <h1>ADD NEW WEBSITE</h1>
        <WebsiteForm onSave={onSave} />
      </Panel>
    </Frame>
  );
};

export default NewWebsite;
